<avano-appheader
  #avanoHeader
  [userName]="username"
  [userOrg]="userOrganization"
  [systemRibbonText]="systemRibbonText"
  [userPopoverTemplate]="userPopoverTemplate"
>
  <avano-appheader-icon-area>
    <avano-notifications-container [title]="translationKeys.appheader.tooltip.notifications | translate"></avano-notifications-container>
    <avano-avano-appheader-icon
      [disabled]="true"
      icon="icon-header-app-switch"
      [title]="translationKeys.appheader.tooltip.appSwitch | translate"
    ></avano-avano-appheader-icon>
    <avano-avano-appheader-icon
      icon="icon-header-logout"
      [title]="translationKeys.appheader.tooltip.logOut | translate"
      (click)="logout()"
    ></avano-avano-appheader-icon>
  </avano-appheader-icon-area>
</avano-appheader>

<ng-template #userPopoverTemplate>
  <ng-container
    *ngIf="avanoHeader.userPopoverUserInfo && user$ | async as userInfo"
    [ngTemplateOutlet]="avanoHeader.userPopoverUserInfo"
    [ngTemplateOutletContext]="{ $implicit: userInfo }"
  ></ng-container>
  <div>
      <ng-container *ngIf="showDashboardConfig">
        <div class="button-container">
          <button
            avanoButton
            [icon]="'icon-content-settings'"
            [label]="translationKeys.dashboard.userSettingsComponent.openBtn | translate"
            (click)="showDashboardDialog = true"
          ></button>
          <scip-dashboard-user-settings *ngIf="showDashboardConfig && showDashboardDialog" (cancelEvent)="showDashboardDialog = false"></scip-dashboard-user-settings>
        </div>
      </ng-container>
  </div>
</ng-template>
